var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23 5.2c-.8.4-1.7.6-2.6.7.9-.6 1.6-1.4 2-2.5-.9.5-1.8.9-2.9 1.1-.8-.9-2-1.4-3.3-1.4-2.5 0-4.5 2-4.5 4.5 0 .4 0 .7.1 1-3.8-.2-7.1-2-9.3-4.7-.4.7-.6 1.4-.6 2.3 0 1.6.8 2.9 2 3.8-.7 0-1.4-.2-2-.6v.1c0 2.2 1.6 4 3.6 4.4-.4 0-.8.1-1.2.1-.3 0-.6 0-.8-.1C4 15.7 5.7 17 7.7 17c-1.6 1.3-3.5 2-5.6 2-.4 0-.7 0-1.1-.1 2 1.3 4.4 2 6.9 2 8.3 0 12.8-6.9 12.8-12.8v-.6c.9-.6 1.7-1.4 2.3-2.3z"}));
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Twitter;

Twitter.default = Twitter;
